import api from "@/lib/api";

const KEY = "hm_visit_session";

export function visitSession() {
  let s = localStorage.getItem(KEY);
  if (!s) {
    s = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(KEY, s);
  }
  return s;
}

export function trackAbandon(step, extra = {}) {
  api.post("/track/abandon", {
    session_id: visitSession(), step, url: window.location.pathname, ...extra,
  }).catch(() => {});
}

export function trackComplete(step, extra = {}) {
  api.post("/track/complete", { session_id: visitSession(), step, ...extra }).catch(() => {});
}
